/**
 * @file Re-exports OptionsDropdown as the entry point of the module.
 */
import OptionsDropdown from "./OptionsDropdown";

export default OptionsDropdown;
